import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import Select from "../../../../components/Form/Select";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  BRAND_SETUP_VERSION_CURRENT,
  BRAND_SETUP_VERSION_LABEL,
  BRAND_SETUP_VERSION_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";

const CURRENT_VERSION_VALUE = "__current__";

const SelectBrandSetupVersion = ({
  versions = [],
  selectedVersionID = null,
  onSelectVersion = () => {},
  isLoading = false,
  disabled = false,
}) => {
  const { t } = useTranslationApp();
  const { control, errors, setValue } = useForm({
    defaultValues: { brandSetupVersion: CURRENT_VERSION_VALUE },
  });

  const selectedValue = selectedVersionID || CURRENT_VERSION_VALUE;

  useEffect(() => {
    setValue("brandSetupVersion", selectedValue);
  }, [selectedValue, setValue]);

  const options = useMemo(() => {
    const currentOption = {
      value: CURRENT_VERSION_VALUE,
      label: t(BRAND_SETUP_VERSION_CURRENT),
    };
    // Versions are sorted newest-first; the latest snapshot matches live brand setup.
    const historicalVersions = versions.slice(1);
    const versionOptions = historicalVersions.map((version) => ({
      value: version.versionID,
      label: t(BRAND_SETUP_VERSION_LABEL, {
        versionNumber: version.versionNumber,
        date: new Date(version.createdAt),
      }),
    }));

    return [currentOption, ...versionOptions];
  }, [versions, t]);

  const onVersionChange = (value) => {
    onSelectVersion({
      versionID: value === CURRENT_VERSION_VALUE ? null : value,
    });
  };

  return (
    <Select
      name="brandSetupVersion"
      control={control}
      errors={errors}
      label={t(BRAND_SETUP_VERSION_PLACEHOLDER)}
      options={options}
      value={selectedValue}
      rules={{ required: false }}
      disabled={disabled || isLoading}
      size="small"
      variant="filled"
      actionsChange={onVersionChange}
      sx={{ minWidth: 240 }}
    />
  );
};

export default SelectBrandSetupVersion;
